module.exports = {
        srcSet: "/_next/static/images/phone-340-d229926c4d0eed69.png"+" 340w"+","+"/_next/static/images/phone-680-239e437d65008edf.png"+" 680w"+","+"/_next/static/images/phone-1020-d42d5b3f9cd09843.png"+" 1020w",
        images: [{path: "/_next/static/images/phone-340-d229926c4d0eed69.png",width: 340,height: 330},{path: "/_next/static/images/phone-680-239e437d65008edf.png",width: 680,height: 660},{path: "/_next/static/images/phone-1020-d42d5b3f9cd09843.png",width: 1020,height: 990}],
        src: "/_next/static/images/phone-1020-d42d5b3f9cd09843.png",
        toString: function(){return "/_next/static/images/phone-1020-d42d5b3f9cd09843.png"},
        
        width: 1020,
        height: 990
      }